import { Organization } from "../models/Organization";
import client from "./axios";

const organizationsUrl = `${window.__env.BASE_URL}/organizations`;

export const Organizations = {
  getOrganizations: () => client.get<Organization[]>(organizationsUrl),
  createOrganization: (organization: Organization) => client.post<Organization>(organizationsUrl, organization),
  getOrganization: (id: string | number) => client.get<Organization>(`${organizationsUrl}/${id}`),
  getMyOrganization: () => client.get<Organization>(`${organizationsUrl}/${'me'}`),
  updateMyOrganization: (organization: Organization) => client.put<Organization>(`${organizationsUrl}/me`,organization),
  updateOrganization: (organization: Organization) => client.put<Organization>(`${organizationsUrl}/${organization.id}`, organization),
  deleteOrganization: (id: number | undefined) => client.delete(`${organizationsUrl}/${id}`),
  uploadOrganizationLogo: (id: number, data: FormData) => client.post(`${organizationsUrl}/${id}/logo`, data, { headers: { "Content-Type": "multipart/form-data" } }),
}